const CardIcon = ({ className }) => (
  <svg
    className={className}
    width="13"
    height="13"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.1875 0H2.1875C0.777 0 0 0.777 0 2.1875V6.85417C0 8.26467 0.777 9.04167 2.1875 9.04167H9.1875C10.598 9.04167 11.375 8.26467 11.375 6.85417V2.1875C11.375 0.777 10.598 0 9.1875 0ZM10.5 6.85417C10.5 7.77408 10.1074 8.16667 9.1875 8.16667H2.1875C1.26758 8.16667 0.875 7.77408 0.875 6.85417V3.79167H10.5V6.85417ZM10.5 2.91667H0.875V2.1875C0.875 1.26758 1.26758 0.875 2.1875 0.875H9.1875C10.1074 0.875 10.5 1.26758 10.5 2.1875V2.91667ZM2.33333 6.27083C2.33333 6.02933 2.52933 5.83333 2.77083 5.83333H4.52083C4.76233 5.83333 4.95833 6.02933 4.95833 6.27083C4.95833 6.51233 4.76233 6.70833 4.52083 6.70833H2.77083C2.52933 6.70833 2.33333 6.51233 2.33333 6.27083Z"
      fill="white"
    />
  </svg>
);

export default CardIcon;
